import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { messages } from '../Resources.messages';

const DeleteResourceModal = () => (
  <Confirm
    title={<Message message={messages.deleteModal.title} />}
    cancelNode={<Message message={messages.deleteModal.cancel} />}
    acceptNode={<Message message={messages.deleteModal.confirm} />}>
    <Message message={messages.deleteModal.description} />
  </Confirm>
);

export default DeleteResourceModal;
